import React from 'react';

import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';
import UserService from './service/auth';
import './index.css';
import App from './App';
import { isPublicRoute } from './routes/PublicRoutes/guards';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const appTree = <App />;

if (isPublicRoute(window.location.pathname)) {
  root.render(appTree);
} else {
  UserService.initKeycloak(root.render(appTree));
}

reportWebVitals();
